import { z } from 'zod';

// Salary Information Validation Schema
export const salaryInformationSchema = z.object({
  salary: z.coerce
    .number()
    .min(0, 'Salary must be 0 or greater')
    .max(999999999, 'Salary must be less than 1 billion')
    .optional(),
  taxId: z.string().trim().optional().nullable(),
});

export type SalaryInformationFormValues = z.infer<typeof salaryInformationSchema>;
